// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xoElt24J [role=row] [role=cell]{width:15%}.xoElt24J [role=row] [role=cell]:nth-child(5){width:40%}`, "",{"version":3,"sources":["webpack://./src/page-components/save/workflow-prompt-statuses.module.scss"],"names":[],"mappings":"AAEI,iCACE,SAAA,CAEA,8CACE,SAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `xoElt24J`
};
export default ___CSS_LOADER_EXPORT___;
